<template>
  <v-snackbar
    v-model="snackbar"
    :color="`${status === 'success' ? 'success' : 'error'}`"
    :multi-line="mode === 'multi-line'"
    :timeout="timeout"
    vertical
    :top="y === 'top'"
    >
    {{ text }}
    <v-btn
      dark
      flat
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  props: ['text', 'status'],
  data () {
    return {
      snackbar: true,
      timeout: 5000,
      y: 'top',
      mode: ''
    }
  }
}
</script>
